<template>
    <div>
      <div class="revslider" :data-alias=" getLocale + '-productos' " :id=" getLocale + '-productos' "></div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return {     
        slider: ''
      }
    },
    created(){
    },
    beforeMount(){    
    },
    computed: mapGetters(['getLocale']),
    mounted(){
      // console.log('mounted');
      // Desactivado tatarana-update
      if( process.env.NODE_ENV == 'production'){
        //jQuery(document).ready(Revslider.init)
      }

      jQuery(document).ready(Revslider.init)
     


      /* Siempre
      jQuery('#es-servicios').show().revolution({
        
       });*/
      //console.log(this.getCurrentSliderAPI())
    },
    methods: {
      /* getCurrentSliderAPI() {
        var slider = jQuery('.rev_slider');
        //console.log(slider)

        if(!slider.length) return false; 
        return eval('revapi' + slider.attr('id').split('rev_slider_')[1].split('_')[0]);
      },
      startSlider() {
        var revapi = this.getCurrentSliderAPI();
        if(revapi) {
          // start new slider
          // assuming the "revapi1.revstart()" option has 
          // been turned on in the slider's General Settings
          revapi.revstart();
        }
      },
      killSlider() { 
        var revapi = this.getCurrentSliderAPI();
        if(revapi) {    
          // destroy current slider
          revapi.revkill();
          revapi = null;     
        }     
      } */
    },
    beforeDestroy(){
      /* var revapi = this.getCurrentSliderAPI();
      console.log(revapi)
      if(revapi) {
        revapi.revkill();
        revapi = null;
      } */
    },
    watch:{
      getLocale: function(){
        //this.killSlider();
        //this.startSlider();
      }
    }
  }
</script>
